export default function assert(condition, message) {
  if (!condition) {
    throw new Error(message || 'viewport-mercator-project: assertion failed.');
  }
}
//# sourceMappingURL=assert.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/viewport-mercator-project/dist/esm/assert.js
// module id = 540
// module chunks = 0